
import apiInstance from '../utils/apiInstance';
import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Table from '../common/Table';

const ContactUs = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const fetchData = async () => {
        try {
            const response = await apiInstance.get("/getContactUsList");
            setData(response.data.contactUsList);
        } catch (error) {
            setError("An error occurred while fetching contact us messages...");
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    const filteredData = data.filter(user =>
        user?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user?.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleDeleteClick = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            customClass: {
                popup: 'custom-swal-popup',
                title: 'custom-swal-title',
                content: 'custom-swal-content',
                confirmButton: 'custom-swal-button',
                cancelButton: 'custom-swal-button'
            }
        });
        if (result.isConfirmed) {
            if (id) {
                setLoading(true);
                try {
                    await apiInstance.delete(`/deleteOneMessage/${id}`);
                    Swal.fire("Deleted!", "Message has been deleted.", "success");
                    fetchData();
                } catch (error) {
                    Swal.fire(
                        "Error!",
                        "Error deleting message",
                        "error"
                    );
                } finally {
                    setLoading(false);
                }
            }
        }

    };

    const options = ['S No.', 'Name', 'Email', 'Phone no.', 'Actions'];

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;

    return (
        <>
            <Table
                contactUs='contactUs'
                heading='Contact Us'
                options={options}
                data={filteredData}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                loading={loading}
                handleDeleteClick={handleDeleteClick}
            />

            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default ContactUs;





